export type DataEvent = Event & { data: string }

export function isDataEvent (event: Event | DataEvent): event is DataEvent {
  return 'data' in event && typeof event.data === 'string'
}

export function handleEvent<T> (handler: (data: T) => void | Promise<void>) {
  return (event: Event) => {
    if (!isDataEvent(event)) return

    // there is no good way of checking that the data
    // is really of type T unfortunately
    const data = JSON.parse(event.data) as T
    void handler(data)
  }
}
